import { Outlet, useSearchParams } from "react-router-dom";
import { Bounce, ToastContainer, Zoom } from "react-toastify";
import {
  Text,
  Box,
  Center,
  Container,
  Flex,
  Heading,
  Icon,
  VStack,
} from "@chakra-ui/react";
import { MenuProps, TopMenu } from "./menu";
import { useGlobalContext } from "./GlobalState";
import { InfoIcon, Tag } from "lucide-react";
import { useEffect, useRef } from "react";
import { useSigninService } from "../Services/SigninService";
import { GET } from "../api/BackendApi";
import "react-toastify/dist/ReactToastify.css";

export const Layout = (props: MenuProps) => {
  const globalContext = useGlobalContext();

  // Check if signed in when Global Context is initiated (first thing when opening the page)
  const signinService = useSigninService();
  useEffect(() => {
    signinService.checkSigninStatus();
  }, []);

  //<ToastContainer style={{}} limit={5} />
  return (
    <>
      <ToastContainer
        position="top-left"
        autoClose={3000}
        limit={3}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Zoom}
      />
      <Flex direction="column" minH="100vh" minW="100vw">
        <Container
          as="header"
          maxW={"100%"}
          background={"black"}
          padding={{ base: "10px", md: "20px" }}
        >
          <TopMenu
            content={props.content}
            appName={globalContext.competition?.tag || props.appName}
          />
        </Container>

        <Container maxW="100%" flexGrow={1} padding={{ base: "10px", md: "20px" }}>
          {!globalContext.authorizedAs ? <NotSignedIn /> : <Outlet />}
        </Container>
      </Flex>
    </>
  );
};

function NotSignedIn() {
  return (
    <Center h="80vh">
      <Box
        maxW="lg"
        borderRadius="md"
        boxShadow="lg"
        p={8}
        bg="white"
        textAlign="center"
      >
        <VStack spacing={6}>
          <Icon as={InfoIcon} w={12} h={12} color="blue.400" />
          <Heading as="h2" size="lg" color="gray.700">
            Du är inte inloggad
          </Heading>
          <Text fontSize="md" color="gray.600">
            För att komma åt programmet behöver du logga in. Den här appen är
            ett administrativt verktyg och är inte allmänt tillgänglig för våra
            medlemmar.
          </Text>
          <Text fontSize="sm" color="gray.500">
            Kontakta Jörgen eller Jonathan om du bör ha men saknar
            inloggningsuppgifter för sidan.
          </Text>
        </VStack>
      </Box>
    </Center>
  );
}
